import React from "react";
import { ContentLoader, Breadcrumb } from "../../../components/Common";
import GamificationForm from "./components/GamificationForm";
import { useGamificationSettings } from "./hooks/useGamificationSettings";

const GamificationSettings = () => {
    document.title = "Configurações de Gamificação | NeoApp";
    const { data, loading, saving, actions } = useGamificationSettings();

    // 4. Loading State Principal
    if (loading) {
        return <ContentLoader message="Carregando Gamificação" />;
    }

    return (
        <React.Fragment>
            <div className="d-flex align-items-center justify-content-between mb-3">
                <Breadcrumb title="Configurações de Gamificação" />
            </div>

            <div className="border-top mb-3"></div>

            <GamificationForm
                initialData={data}
                onSave={actions.handleSubmit}
                isSaving={saving}
            />
        </React.Fragment>
    );
};

export default GamificationSettings;
